import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { QRCodePrintWithFactory } from './Pages';

export const QRCodePrintWithFactoryRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={QRCodePrintWithFactory} />
       
    </Fragment>
)